module.exports = __webpack_public_path__ + "img/ko.602a5075.svg";